import { Injectable } from '@angular/core';
import { OmniAnalyticsService } from '@cigna/omni/shared';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import {
  dismissFancyInvitation,
  trackReplyToMessageFancyInvitation,
  fancyInvitationsViewed,
} from './fancy-invitations.actions';

@Injectable()
export class FancyInvitationsEffects {
  constructor(
    private actions$: Actions,
    private analyticsService: OmniAnalyticsService,
  ) {}

  fancyInvitationsViewed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fancyInvitationsViewed),
        tap(() =>
          this.analyticsService.trackEvent('fancyInvitationViewed', {}),
        ),
      ),
    { dispatch: false },
  );

  fancyInvitationsDismissed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(dismissFancyInvitation),
        tap(() =>
          this.analyticsService.trackEvent('fancyInvitationDismissed', {}),
        ),
      ),
    { dispatch: false },
  );

  fancyInvitationsReplyToMessageAnalytics$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(trackReplyToMessageFancyInvitation),
        tap(() =>
          this.analyticsService.trackEvent('fancyInvitationReplyToMessage', {}),
        ),
      ),
    { dispatch: false },
  );
}
